import { render, staticRenderFns } from "./Orders2Skeleton.vue?vue&type=template&id=27d4a620&"
import script from "./Orders2Skeleton.vue?vue&type=script&lang=js&"
export * from "./Orders2Skeleton.vue?vue&type=script&lang=js&"
import style0 from "./Orders2Skeleton.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports